import type React from "react";

interface SpeakerIconProps {
  className?: string;
  style?: React.CSSProperties;
  isOn?: boolean;
}

export const SpeakerOnIcon: React.FC<SpeakerIconProps> = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path d="M5 15V9C5 8.72386 5.22386 8.5 5.5 8.5H9.32461C9.43815 8.5 9.5483 8.46136 9.63696 8.39043L16.1877 3.14988C16.515 2.88797 17 3.12106 17 3.54031V20.4597C17 20.8789 16.515 21.112 16.1877 20.8501L9.63696 15.6096C9.5483 15.5386 9.43815 15.5 9.32461 15.5H5.5C5.22386 15.5 5 15.2761 5 15Z" stroke="white" strokeWidth="2" />
  </svg>
);

export const SpeakerOffIcon: React.FC<SpeakerIconProps> = ({ className, style }) => (
  <svg
    className={className}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path d="M6 10.4141V14H9.04785C9.12504 13.991 9.20309 13.991 9.28027 14H9.58594L15.8789 20.293C16.2692 20.6834 16.2692 21.3165 15.8789 21.707C15.4884 22.0974 14.8554 22.0974 14.4648 21.707L8.75781 16H5C4.93116 16 4.86375 15.9927 4.79883 15.9795C4.73363 15.9662 4.67025 15.9472 4.61035 15.9219C4.28153 15.7827 4.04252 15.4721 4.00488 15.1025C4.00145 15.0688 4 15.0346 4 15V9C4.00001 8.8305 4.04276 8.67113 4.11719 8.53125L6 10.4141ZM3.70703 3.70703C4.09757 3.31674 4.73065 3.31658 5.12109 3.70703L20.2305 18.8164C20.6209 19.2069 20.6208 19.8399 20.2305 20.2305C19.8399 20.621 19.2069 20.621 18.8164 20.2305L3.70703 5.12109C3.31651 4.73057 3.31651 4.09756 3.70703 3.70703ZM15.5137 2.37598C16.4815 1.51887 18.0084 2.20631 18.0088 3.49902V13.502C18.0088 13.5288 18.007 13.5557 18.0049 13.582L16.0088 11.6523V4.60938L12.2061 7.97754L10.7646 6.58398L15.5137 2.37598Z" fill="#F5363C"/>
  </svg>
);

export const SpeakerIcon: React.FC<SpeakerIconProps> = ({
  className,
  style,
  isOn = true,
}) => {
  return isOn ? (
    <SpeakerOnIcon className={className} style={style} />
  ) : (
    <SpeakerOffIcon className={className} style={style} />
  );
};
